import React from 'react';
import { iconStyle, disabledIconStyle, svgStyle } from '../styles';

const SVG = function SVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="46px"
      height="46px"
      viewBox="0 0 46 46"
      style={svgStyle}
    >
      <defs>
        <filter
          x="-50%"
          y="-50%"
          width="200%"
          height="200%"
          filterUnits="objectBoundingBox"
          id="filter-1"
        >
          <feOffset
            dx="0"
            dy="1"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            stdDeviation="0.5"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.168 0"
            in="shadowBlurOuter1"
            type="matrix"
            result="shadowMatrixOuter1"
          />
          <feOffset
            dx="0"
            dy="0"
            in="SourceAlpha"
            result="shadowOffsetOuter2"
          />
          <feGaussianBlur
            stdDeviation="0.5"
            in="shadowOffsetOuter2"
            result="shadowBlurOuter2"
          />
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.084 0"
            in="shadowBlurOuter2"
            type="matrix"
            result="shadowMatrixOuter2"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="shadowMatrixOuter2" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <rect id="path-2" x="0" y="0" width="40" height="40" rx="2" />
        <rect id="path-3" x="5" y="5" width="38" height="38" rx="1" />
      </defs>
      <g
        id="Microsoft-Button"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="btn" transform="translate(-1.000000, -1.000000)">
          <path d="M0 0h104v41H0z" />
          <path fill="#f25022" d="M13 11h9v9h-9z" />
          <path fill="#00a4ef" d="M13 21h9v9h-9z" />
          <path fill="#7fba00" d="M23 11h9v9h-9z" />
          <path fill="#ffb900" d="M23 21h9v9h-9z" />
        </g>
      </g>
    </svg>
  );
};

const MicrosoftIcon = function MicrosoftIcon({
  disabled = false,
  // type = 'light',
}) {
  if (disabled) return null;
  return (
    <div style={{ iconStyle: { ...iconStyle, ...disabledIconStyle } }}>
      {SVG()}
    </div>
  );
};
export default MicrosoftIcon;
